<div *ngIf="invoice.statusFinanceiroIntegration === StatusFinanceiroIntegration.CANCELED" [pTooltip]="Cancelado">
    <i class="pi pi-ban red-icon" pTooltip="Cancelado"></i>
</div>

<div *ngIf="invoice.statusFinanceiroIntegration === StatusFinanceiroIntegration.CREATED" [pTooltip]="Criado">
    <i class="pi pi-check" pTooltip="Registrado"></i>
</div>

<div *ngIf="invoice.statusFinanceiroIntegration === StatusFinanceiroIntegration.WAITING">
    <i class="pi pi-spinner" pTooltip="Aguardando"></i>
</div>

<div *ngIf="invoice.statusFinanceiroIntegration === StatusFinanceiroIntegration.ERROR">
    <i class="pi pi-times cursor-pointer" (click)="updateInvoice()" pTooltip="Erro"></i>
</div>